import { useCallback, useRef } from "react";
import { Modal, Button, Box } from "@mui/material";
import Webcam from "react-webcam";

export const BasePhotoModal = ({
  show,
  handleClose,
  picture,
  setPicture,
  onSave,
  title,
}) => {
  const videoConstraints = {
    width: 400,
    height: 400,
    facingMode: "user",
  };

  const webcamRef = useRef(null);

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setPicture(pictureSrc);
  }, [webcamRef, setPicture]);

  const handleCapture = (e) => {
    e.preventDefault();
    capture();
  };

  const handleConfirmPhoto = () => {
    onSave(picture);
    handleClose();
  };

  return (
    <Modal
      open={show}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "40px",
          maxWidth: "650px",
          width: "100%",
          maxHeight: "90vh",
          outline: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3>{title}</h3>
          <Button onClick={handleClose} variant="outlined">
            X
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "24px",
          }}
        >
          {picture === "" || picture === undefined ? (
            <Webcam
              audio={false}
              height={400}
              ref={webcamRef}
              width={400}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ borderRadius: "8px" }}
            />
          ) : (
            <img
              src={picture}
              alt={title}
              style={{ maxWidth: "400px", borderRadius: "8px" }}
            />
          )}
          <div style={{ display: "flex", gap: "16px" }}>
            {picture ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmPhoto}
                >
                  Confirmar
                </Button>
                <Button variant="outlined" onClick={() => setPicture("")}>
                  Tomar de nuevo
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleCapture}
              >
                Tomar foto
              </Button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};
